import React, { FC, ReactElement, useContext } from 'react'
import { SelfProvisioning as SelfProvisioningLanguage } from '../../../../i18n'
import CLanguageHandler from '../../../NonReact/Languages/LanguageHandler'
import { IconName } from '../../Common/Components/Icon'
import { IconPopper } from '../../Common/Components/IconPopper/IconPopper'
import { LanguageContext } from '../../Common/Contexts'
import { LanguageUtils } from '../../Common/Utils/LanguageUtils'
import { FooterActions } from '../Actions/FooterActions'
import { SelfProvisioningContext, SelfProvisioningContextType } from '../Contexts/SelfProvisioningContext'

/**
 * View the user sees upon starting the self provisioning process.
 */
export const Welcome: FC = (): ReactElement => {
    const language: CLanguageHandler = useContext(LanguageContext) as CLanguageHandler
    const { nextStep }: SelfProvisioningContextType = useContext(SelfProvisioningContext)

    return (
        <div className='welcome-view'>
            <div className='wv-para wv-para-1'>
                {LanguageUtils.formatLanguageEntry(
                    language.get(SelfProvisioningLanguage.SelfProvisioning_Welcome_Para_1)
                )}
            </div>

            <div className='wv-para wv-para-2'>
                {LanguageUtils.formatLanguageEntry(
                    language.get(SelfProvisioningLanguage.SelfProvisioning_Welcome_Para_2)
                )}
                <IconPopper iconName={IconName.HELP} className='welcome-help'>
                    {LanguageUtils.formatLanguageEntry(
                        language.get(SelfProvisioningLanguage.SelfProvisioning_Welcome_Help)
                    )}
                </IconPopper>
            </div>

            <div className='wv-para wv-para-3'>
                {LanguageUtils.formatLanguageEntry(
                    language.get(SelfProvisioningLanguage.SelfProvisioning_Welcome_Para_3)
                )}
            </div>

            <div className='wv-para wv-para-4'>
                {LanguageUtils.formatLanguageEntry(
                    language.get(SelfProvisioningLanguage.SelfProvisioning_Welcome_Para_4)
                )}
            </div>

            <FooterActions
                showRightSideButton
                rightSideButtonLabel={language.get(SelfProvisioningLanguage.SelfProvisioning_FooterActions_Next)}
                rightSideButtonType='button'
                rightSideButtonClick={nextStep}
            />
        </div>
    )
}
